import PropTypes from 'prop-types';
import { useCallback } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { theme } from '_constants/theme';
import Button from '_components/atomic/Button';

const { colors, devices, fontSizes, spaces } = theme;

const StyledBottomNavigationSection = styled.div`
  display: flex;
  flex-direction: row;
  padding: 60px 0px;
  gap: 30px;
  border-width: 1px 0px;
  border-style: solid;
  border-color: ${colors.gray[200]};
  max-width: ${spaces.large24X * 10 + 80}px;
  width: 100%;
  justify-content: space-between;
  @media ${devices.tablet} {
    padding: ${spaces.large}px ${spaces.regular}px;
  }
`;
const StyledService = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => (align === 'left' ? 'flex-start' : 'flex-end')};
  .direction {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-size: ${fontSizes.regular}px;
    line-height: 150%;
    text-transform: uppercase;
    color: ${colors.gray[700]};
  }
  .title {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 500;
    font-size: ${fontSizes.large8X}px;
    line-height: 140%;
    color: ${colors.gray[800]};
    padding-top: ${spaces.small - 2}px;
    padding-bottom: ${spaces.medium}px;
    cursor: pointer;
  }
  @media ${devices.tablet} {
    .direction {
      font-size: ${fontSizes.small}px;
      line-height: 21px;
    }
    .title {
      font-size: ${fontSizes.medium}px;
      line-height: 27px;
      padding: 0px;
    }
    .button {
      display: none;
    }
  }
`;
const BottomNavigationSection = ({ previousService, nextService }) => {
  const router = useRouter();

  const handlePrev = useCallback(() => {
    router.push(previousService.link);
  }, [router, previousService]);

  const handleNext = useCallback(() => {
    router.push(nextService.link);
  }, [router, nextService]);

  return (
    <StyledBottomNavigationSection>
      <StyledService align="left">
        <div className="direction">Previous Service</div>
        <div className="title" onClick={handlePrev}>
          {previousService.title}
        </div>
        <div className="button">
          <Button outlined color={colors.indigo[600]} onClick={handlePrev}>
            Learn more
          </Button>
        </div>
      </StyledService>
      <StyledService align="right">
        <div className="direction">Next Service</div>
        <div className="title" onClick={handleNext}>
          {nextService.title}
        </div>
        <div className="button">
          <Button outlined color={colors.indigo[600]} onClick={handleNext}>
            Learn more
          </Button>
        </div>
      </StyledService>
    </StyledBottomNavigationSection>
  );
};

BottomNavigationSection.propTypes = {
  previousService: PropTypes.shape({
    title: PropTypes.node,
    link: PropTypes.string,
  }),
  nextService: PropTypes.shape({
    title: PropTypes.node,
    link: PropTypes.string,
  }),
};

export default BottomNavigationSection;
